// const host = "http://localhost:5000";
const host = "https://api-staging.viabber.com";
// const host = "https://viabber-api.herokuapp.com";
// const host = "https://apitest.viabber.com:8181";
export default host;
